export default __webpack_public_path__ + "static/media/favicon.f77d6895.ico";